import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MediaBrowseComponent } from './media-browse/media-browse.component';
import { ImagesPageComponent } from './images-page/images-page.component';
import { VideosPageComponent } from './videos-page/videos-page.component';

const routes: Routes = [
  {
    path: 'media',
    component: MediaBrowseComponent,
    children: [
      { path: '', redirectTo: 'images', pathMatch: 'full' },
      { path: 'images', component: ImagesPageComponent },
      { path: 'videos', component: VideosPageComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MediaRoutingModule {}
